
import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '@/components/common/organisms/PaginationButton.vue'

export type BranchData = {
  branchId: number
  branchCode: string
  branchName: string
  created_at: string
  updated_at: string
}

export type BranchSearchQuery = {
  branchCode?: string
  branchName?: string
}

export type BranchObject = {
  pagination: Pagination
  responses: BranchData[]
}

@Component
export default class BranchListApis extends Vue {
  /**
   * 教室一覧取得
   */
  protected async searchBranches(Page: number, BranchSearchQuery: BranchSearchQuery): Promise<BranchObject> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/academy/branch/search?page=${Page}`, {
      params: BranchSearchQuery,
    })
    return data
  }

  /**
   * エクセルアップロード
   */
  protected async importExcel(file: File): Promise<boolean> {
    const headers = { 'Content-Type': 'multipart/form-data' }
    const params = new FormData()
    params.append('excel', file)
    const { data } = await Vue.prototype.$http.httpWithToken.post('/v1/academy/branch/import', params, {
      headers: headers,
    })
    return data
  }

  /**
   * エクセル出力
   */
  protected async exportExcel(branchSearchQuery: BranchSearchQuery): Promise<{ url: string; filename: string }> {
    let res: { data: Blob } = await Vue.prototype.$http.httpWithToken.get('/v1/academy/branch/export', {
      params: branchSearchQuery,
      responseType: 'blob',
      dataType: 'binary',
    })
    return {
      url: URL.createObjectURL(res.data),
      filename: '教室一覧.xlsx',
    }
  }
}
